module.exports = __webpack_public_path__ + "img/1.aa5d29b3.jpg";